import { ApiPatchOperation } from '@domain/schemas/api-patch-operation';
import type { PatchSyncSubmissionDataResponse } from '@responses/submissions';

import { patchEntity } from './patchEntity';

export const syncData = async (keepLocal?: boolean): Promise<PatchSyncSubmissionDataResponse> => {
  const response = await patchEntity({
    operation: ApiPatchOperation.SyncSubmissionData,
    keepLocal,
  });

  return response;
};
